import {
  anItemMeta,
  aSuppressListItem,
  aSuppressListItemPage,
  mockSuppressedListItemsOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

const EXPIRATION_DATE = new Date().setFullYear(new Date().getFullYear() + 1);

export const SUPPRESSED_LIST_ITEM_DATA = {
  value: 'test suppressed list item value',
  description: 'Test suppressed list item description',
  expiration: new Date(EXPIRATION_DATE).toISOString(),
  updatedDescription: 'Test suppressed list item description updated',
};

export const suppressedListItemsHandler = ({
  id,
  value,
  expiration,
  description,
}) => ({
  __typename: 'Query',
  suppressListItems: aSuppressListItemPage({
    hasNextPage: false,
    objects: [
      aSuppressListItem({
        id,
        value,
        expiration,
        meta: anItemMeta({
          description,
        }),
      }),
    ],
    total: 1,
  }),
});

export const handlers = [
  mockSuppressedListItemsOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          suppressListItems: aSuppressListItemPage(),
        },
      });
    }
  ),
];
